import {
  normalizeObjError,
  processName,
} from '@bit/gerenciatd.utils.ada-byron';
import { api } from '@bit/gerenciatd.utils.monitoring-utils';
import Request, { getMockedInfo } from '@bit/gerenciatd.utils.request';
import Sonda from '@bit/gerenciatd.utils.sonda';
import {
  Context,
  ENV_NAME,
  MethodType,
  UnknownObject,
} from '@bit/gerenciatd.utils.types';

enum PATHS {
  GET_BY_NAME = '/cms/{kind}/getByName',
  GET_SEO = '/api/seo/get',
  GET_INFO_RECOM = '/perso/getInfoRecom',
  GET_PRODUCT_EVALUATERULES_DISTRI_FUSION = '/perso/evaluateRules',
}
/* GET BY NAME */
let newTabOpen = false;

export const getByNameError = (
  response: XMLHttpRequest,
  envName = '',
  endpoint: string,
): null => {
  if (
    !newTabOpen &&
    (envName === ENV_NAME.QA || envName === ENV_NAME.DEV) &&
    response &&
    response.statusText === 'Network Error'
  ) {
    newTabOpen = true;
    try {
      window.open(endpoint);
    } catch (err) {
      console.log(`[Error Opening Custo Tab]: ${err}`);
    }
  }
  return null;
};

export const getByName = (
  data: UnknownObject,
  kind = 'activity',
  idFront = 'VT',
): Promise<unknown> => {
  const myData = { ...data };
  const context = myData.context as Context;
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: 'CUSTOMIZER.ACTIVITY.GETBYNAME',
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { custo: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;

  const URL_API = `${host}${PATHS.GET_BY_NAME.replace(
    '{kind}',
    kind,
  )}?${idRequest}`;

  const mockInfo = getMockedInfo('getByName', name);

  try {
    const request = new Request({
      method: MethodType.POST,
      endpoint: URL_API,
      data: myData,
      onError: (response: XMLHttpRequest) =>
        getByNameError(response, name, URL_API),
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};

export const getSEO = (
  data: {
    navigationSegment: string;
    location: string;
    customValues?: string;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { navigationSegment, location, customValues = '{}' } = data;
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: 'CUSTOMIZER.SEO.GETBYOBJ',
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { custo: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;

  const URL_API = `${host}${PATHS.GET_SEO}?${idRequest}`;

  const mockInfo = getMockedInfo('getSEO', name);

  const requestData = {
    SEG_NAV: navigationSegment,
    location,
    context,
    customValues,
  };

  try {
    const request = new Request({
      method: MethodType.POST,
      endpoint: URL_API,
      data: requestData,
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};

export const getInfoRecomError = (
  response: XMLHttpRequest,
  context: Context,
): UnknownObject => {
  const objError = normalizeObjError(response, context);

  // si el normalizador no consigue meter un response
  if (objError && !objError.response) {
    return {
      ...objError,
      response: {
        error: true,
      },
    };
  }
  return objError;
};

export const getInfoRecomSuccess = (xhr: XMLHttpRequest): UnknownObject => {
  const { response } = xhr;
  const { data } = JSON.parse(response);
  if (data.infoRecom && data.infoRecom.ctz_businessClusters) {
    return {
      infoRecom: {
        ...data.infoRecom,
        ctz_businessClusters:
          JSON.parse(data.infoRecom.ctz_businessClusters) || [],
      },
    };
  }
  return null;
};

export const getInfoRecom = (
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: 'CUSTOMIZER.GET_INFO_RECOM',
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { custo: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;

  const URL_API = `${host}${PATHS.GET_INFO_RECOM}?${idRequest}`;

  const mockInfo = getMockedInfo('getInfoRecom', name);

  const dataEntry = {
    ga: context.clientIDs && context.clientIDs.ga ? context.clientIDs.ga : '',
    pageId: (context.clientIDs && context.clientIDs.pageId) || 'sinPageId',
    session: (context.clientIDs && context.clientIDs.sessId) || null,
    url: window.location.href,
    context,
  };

  try {
    const request = new Request({
      method: MethodType.POST,
      endpoint: URL_API,
      data: dataEntry,
      onError: (response: XMLHttpRequest) =>
        getInfoRecomError(response, context),
      onSuccess: (response: XMLHttpRequest) => getInfoRecomSuccess(response),
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};

export const getProductEvaluateRulesdistriFusionSuccess = (
  xhr: XMLHttpRequest,
): UnknownObject => {
  const { response } = xhr;
  return JSON.parse(response);
};

export const getProductEvaluateRulesDistriFusion = (
  data: {
    viewType?: string;
    faqs?: string;
    subproducts?: string;
    products: {
      prodCode?: string;
      promoCode?: string;
      recomType?: string;
      aliasType?: string;
    }[];
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const dataRequest = data;
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: 'CUSTOMIZER.GET_PRODUCT_EVALUATERULES_DISTRI_FUSION',
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { custo: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;

  const URL_API = `${host}${PATHS.GET_PRODUCT_EVALUATERULES_DISTRI_FUSION}?${idRequest}`;

  const mockInfo = getMockedInfo('getProductEvaluateRulesDistriFusion', name);

  /* normalizing input */
  const inputProducts = dataRequest;

  try {
    const request = new Request({
      method: MethodType.POST,
      endpoint: URL_API,
      data: inputProducts,
      onSuccess: (response: XMLHttpRequest) =>
        getProductEvaluateRulesdistriFusionSuccess(response),
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};
